export const DEVICE_EVENT = 'DEVICE_EVENT';
export const HOLDER_INSERTED = 'HOLDER_INSERTED';
export const HOLDER_EXTRACTED = 'HOLDER_EXTRACTED';
